import { CALL_API } from './api'
import moment from 'moment-timezone'
import {
    getToken,
    getAllToken,
    setToken,
    dateTimeFormat,
    CORE_API_ENDPOINT
} from 'Lib'

export default store => next => action => {
    const entry = action[CALL_API]

    if (typeof entry !== 'object') return next(action)

    const isCORE = entry.types[0].startsWith("CORE")

    if (isCORE) {
        const token = getToken()

        if (!token) return next(action)

        const { expires_on } = getAllToken()
        const currentTime = moment().format(dateTimeFormat)
        const duration = moment.duration(moment.unix(expires_on).diff(currentTime))
        const minutes = duration.asMinutes()

        if (minutes < 10) {
            console.log('request new token')
            fetch(`${CORE_API_ENDPOINT}/user/verify`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                // body: JSON.stringify({ access_token })
            })
                .then(res => res.json())
                .then(json => {
                    const {
                        token,
                        expires_on,
                        isIntegration,
                        user
                    } = json

                    let body = {
                        token,
                        expires_on,
                        isIntegration: isIntegration,
                        firstName: user.firstName,
                        lastName: user.lastName,
                        email: user.email,
                        isAdmin: user.isAdmin,
                    }
                    setToken(body)
                })
                .then(() => next(action))
        } else {
            next(action)
        }
        // next(action)
    } else {
        next(action)
    }
}


// WEBPACK FOOTER //
// ./src/display/middlewares/checkToken.js